/**
 * Merge Judge.me review widget data into the theme Product JSON-LD when
 * individual Review nodes were not emitted server-side (metafield empty).
 * Skips if reviews already exist or Judge.me already injected Review schema.
 */
(function () {
  function findProductLd() {
    var scripts = document.querySelectorAll('script[type="application/ld+json"]');
    for (var i = 0; i < scripts.length; i++) {
      try {
        var data = JSON.parse(scripts[i].textContent);
        if (
          data &&
          (data['@type'] === 'Product' || data['@type'] === 'ProductGroup')
        ) {
          return { script: scripts[i], data: data };
        }
      } catch (e) {
        /* ignore invalid blocks */
      }
    }
    return null;
  }

  function pageAlreadyHasReviews() {
    var scripts = document.querySelectorAll('script[type="application/ld+json"]');
    for (var i = 0; i < scripts.length; i++) {
      try {
        var data = JSON.parse(scripts[i].textContent);
        if (!data) continue;
        if (data.review) return true;
        if (data['@type'] === 'Review') return true;
        if (Array.isArray(data)) {
          for (var j = 0; j < data.length; j++) {
            if (data[j] && (data[j]['@type'] === 'Review' || data[j].review)) {
              return true;
            }
          }
        }
      } catch (e) {
        /* ignore */
      }
    }
    return false;
  }

  function mapReview(r) {
    var name = r.reviewer_name || r.author || 'Customer';
    if (r.is_anonymous_reviewer || !name) name = 'Customer';
    var body = r.body || r.review_body || '';
    var rating = Number(r.rating || r.score || 0);
    var item = {
      '@type': 'Review',
      author: { '@type': 'Person', name: name },
      reviewRating: {
        '@type': 'Rating',
        ratingValue: rating,
        bestRating: '5',
        worstRating: '1',
      },
    };
    if (r.created_at || r.date) {
      var d = new Date(r.created_at || r.date);
      if (!isNaN(d.getTime())) {
        item.datePublished = d.toISOString().slice(0, 10);
      }
    }
    if (r.title) item.name = String(r.title).replace(/<[^>]*>/g, '');
    if (body) item.reviewBody = String(body).replace(/<[^>]*>/g, '').slice(0, 5000);
    return item;
  }

  function getJudgeMeReviews() {
    if (!window.jdgm || !jdgm.data || !jdgm.data.reviewWidget) return null;
    var widgets = jdgm.data.reviewWidget;
    var ids = Object.keys(widgets);
    for (var i = 0; i < ids.length; i++) {
      var w = widgets[ids[i]];
      if (w && Array.isArray(w.reviews) && w.reviews.length) {
        return w.reviews.slice(0, 10).map(mapReview);
      }
    }
    return null;
  }

  function apply() {
    if (pageAlreadyHasReviews()) return true;
    var reviews = getJudgeMeReviews();
    if (!reviews || !reviews.length) return false;
    var target = findProductLd();
    if (!target) return false;
    target.data.review = reviews;
    if (!target.data.aggregateRating && window.jdgm && jdgm.data.reviewWidget) {
      var w = jdgm.data.reviewWidget[Object.keys(jdgm.data.reviewWidget)[0]];
      if (w && Number(w.number_of_reviews) > 0) {
        target.data.aggregateRating = {
          '@type': 'AggregateRating',
          ratingValue: String(w.average_rating),
          bestRating: '5',
          worstRating: '1',
          ratingCount: Number(w.number_of_reviews),
          reviewCount: Number(w.number_of_reviews),
        };
      }
    }
    target.script.textContent = JSON.stringify(target.data);
    return true;
  }

  var attempts = 0;
  var maxAttempts = 40;
  function tick() {
    if (apply() || ++attempts >= maxAttempts) return;
    setTimeout(tick, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tick);
  } else {
    tick();
  }
})();